import { apiFetch } from './api';
import type { Battery, Device, VendorPrice } from '../types/models';

export function getBattery(id: string): Promise<{ battery: Battery; vendors: VendorPrice[] }> {
  return apiFetch<{ battery: Battery; vendors: VendorPrice[] }>(`/batteries/${id}`);
}

export function compatibleDevices(batteryId: string): Promise<Device[]> {
  return apiFetch<Device[]>(`/batteries/${batteryId}/devices`);
}
